import React from 'react';
// @ts-ignore
import variables from 'styles/_variables.scss';
import { IIconProps } from './IIconProps';

interface LogoIconProps extends IIconProps {
	dark?: true;
}

export const LogoIcon = ({
	iconClass = '',
	title = '',
	dark,
}: LogoIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 117 32"
			className={`icon ${iconClass}`}
		>
			{title && <title>{title}</title>}
			<path
				fill={`${dark ? `${variables.bgIconLogo}` : '#fff'}`}
				d="M9.721
				19.284l4.832-10.743h4.889l-8.092
				17.613h-3.259l-8.092-17.613h4.889l4.832 10.743z"
			/>
			<path
				fill={`${dark ? `${variables.bgIconLogo}` : '#fff'}`}
				d="M27.705 8.181c5.325 0 9.361 4.1 9.361 9.186s-4.017 9.148-9.361
				9.148c-5.325 0-9.361-4.062-9.361-9.148s4.017-9.186 9.361-9.186zM27.705
				22.169c2.748 0 4.643-2.145 4.643-4.802s-1.895-4.84-4.643-4.84
				-4.643
				2.183-4.643 4.84c0 2.657 1.876 4.802 4.643 4.802z"
			/>
			<path
				fill={`${dark ? `${variables.bgIconLogo}` : '#fff'}`}
				d="M71.783 0c1.706 0 3.089 1.31 3.089 3.018s-1.383 3.018-3.089
				3.018c-1.706 0-3.089-1.31-3.089-3.018s1.383-3.018 3.089-3.018zM74.133
				26.154h-4.719v-17.613h4.719v17.613z"
			/>
			<path
				fill={`${dark ? `${variables.bgIconLogo}` : '#fff'}`}
				d="M84.328 8.541v-0.55c0-1.632 0.246-2.297 0.644-2.79 0.588-0.683
				1.478-1.025 2.653-1.025 0.436 0 1.023 0.076 1.421
				0.19l0.72-4.024c-0.985-0.266-1.857-0.342-2.786-0.342-2.388 0-4.245
				0.873-5.477 2.069s-1.895 2.904-1.895
				5.732v0.74h-3.847v3.986h3.847v13.627h4.719v-13.627h5.041l5.894
				11.843-3.544 7.63h4.927l10.802-23.459h-4.965l-4.756
				10.572-5.154-10.572h-8.243z"
			/>
			<path
				fill={`${dark ? `${variables.bgIconLogo}` : '#fff'}`}
				d="M61.095 17.348l6.576-8.807h-5.401l-3.885 5.181 2.71 3.625z"
			/>
			<path
				fill={`${dark ? `${variables.bgIconLogo}` : '#fff'}`}
				d="M47.944 17.348l3.885-5.181-2.71-3.625-3.866 5.181 2.691 3.625z"
			/>
			<path
				fill={`${dark ? `${variables.bgIconLogo}` : '#fff'}`}
				d="M42.543 17.348l-6.576 8.807h5.42l3.866-5.181-2.71-3.625z"
			/>
			<path
				fill={`${dark ? `${variables.bgIconLogo}` : '#fff'}`}
				d="M55.694 17.348l-3.866 5.181 2.691 3.625 3.866-5.181-2.691-3.625z"
			/>
			<path
				fill={variables.accentColor}
				d="M35.967 8.541h5.42l13.132 17.613h-5.401l-13.151-17.613z"
			/>
			<path
				fill={variables.accentColor}
				d="M49.119 8.541h5.401l13.151 17.613h-5.401l-13.151-17.613z"
			/>
			<path
				fill={`${dark ? `${variables.bgIconLogo}` : '#fff'}`}
				d="M 110.140625 8.257812 C 111.214844 8.257812 112.085938 9.132812
				112.085938 10.210938 C 112.085938 11.289062 111.214844 12.164062
				110.140625 12.164062 C 109.066406 12.164062 108.191406 11.289062
				108.191406 10.210938 C 108.191406 9.132812 109.066406 8.257812
				110.140625 8.257812 M 110.140625 11.773438 C 111.003906 11.773438
				111.699219 11.074219 111.699219 10.210938 C 111.699219 9.34375
				111.003906 8.648438 110.140625 8.648438 C 109.277344 8.648438
				108.582031 9.34375 108.582031 10.210938 C 108.582031 11.074219
				109.277344 11.773438 110.140625 11.773438 M 109.871094 10.371094
				L 109.871094 11.277344 L 109.386719 11.277344 L 109.386719 9.136719
				L 110.144531 9.136719 C 110.414062 9.136719 110.5625 9.199219
				110.679688 9.304688 C 110.8125 9.421875 110.890625 9.589844
				110.890625 9.785156 C 110.890625 10.003906 110.785156 10.175781
				110.617188 10.277344 C 110.578125 10.304688 110.535156 10.320312
				110.484375 10.339844 L 111.125 11.277344 L 110.597656 11.277344
				L 110 10.371094 Z M 110.160156 9.976562 C 110.273438 9.976562
				110.328125 9.953125 110.367188 9.902344 C 110.390625 9.875 110.40625
				9.832031 110.40625 9.785156 C 110.40625 9.734375 110.390625 9.691406
				110.367188 9.664062 C 110.328125 9.617188 110.273438 9.585938
				110.160156 9.585938 L 109.871094 9.585938 L 109.871094 9.976562
				Z M 110.160156 9.976562 "
			/>
		</svg>
	);
};
